if (!customElements.get('btl-category-browser')) {
  customElements.define('btl-category-browser', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-category-index]')];
      this.panels = [...this.querySelectorAll('[data-category-panel]')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-category-index]');
        if (tab && this.contains(tab)) this.select(Number(tab.dataset.categoryIndex), true);
      }, options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      this.closest('details')?.addEventListener('toggle', () => this.loadImages(this.panels[this.selectedIndex]), options);
      this.showDepartment(this.dataset.department || 'all');
      if (window.Shopify?.designMode && this.dataset.mobileRoot) {
        document.addEventListener('shopify:block:select', event => {
          if (window.matchMedia('(min-width: 990px)').matches) return;
          const blockId = event.detail?.blockId;
          const tab = this.tabs.find(item => item.dataset.editorCategory &&
            (blockId === item.dataset.editorCategory || blockId?.endsWith('__' + item.dataset.editorCategory)));
          if (!tab) return;
          this.showDepartment('all');
          const drawer = this.closest('details');
          if (drawer) drawer.open = true;
          this.select(this.tabs.indexOf(tab), false, false);
        }, options);
      }
    }
    showDepartment(department, category) {
      if (!this.tabs?.length) return 0;
      const matching = this.tabs.filter(tab => category
        ? tab.dataset.parentCategory === category
        : department === 'all' || tab.dataset.department === 'both' || tab.dataset.department === department);
      // An incomplete department setup must still leave the category menu usable.
      const visible = matching.length ? matching : this.tabs;
      this.tabs.forEach(tab => { tab.hidden = !visible.includes(tab); });
      this.select(this.tabs.indexOf(visible[0]), false, false);
      return visible.length;
    }
    select(index, focus = false, animate = true) {
      const selected = this.tabs?.[index];
      const panel = this.panels?.[index];
      if (!selected || selected.hidden || !panel) return;
      this.motion?.cancel();
      this.tabs.forEach((tab, position) => {
        tab.setAttribute('aria-current', String(position === index));
        this.panels[position].hidden = position !== index;
      });
      panel.scrollTop = 0;
      this.selectedIndex = index;
      this.loadImages(panel);
      if (focus) selected.focus();
      if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof panel.animate === 'function') {
        this.motion = panel.animate([{ opacity: 0.75, transform: 'translateY(3px)' }, { opacity: 1, transform: 'none' }],
          { duration: 140, easing: 'cubic-bezier(.22,.61,.36,1)' });
      }
    }
    loadImages(panel) {
      if (!panel || this.closest('details')?.open === false || this.closest('[data-category-popover]')?.hidden) return;
      panel.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
    }
    onKeydown(event) {
      const tab = event.target.closest('[data-category-index]');
      if (!tab || !this.contains(tab)) return;
      const visible = this.tabs.filter(item => !item.hidden);
      const current = visible.indexOf(tab);
      let next;
      if (event.key === 'ArrowDown') next = (current + 1) % visible.length;
      else if (event.key === 'ArrowUp') next = (current - 1 + visible.length) % visible.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = visible.length - 1;
      else return;
      event.preventDefault();
      this.select(this.tabs.indexOf(visible[next]), true);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.motion?.cancel();
    }
  });
}
